import { useFeatureContext } from '../../../contexts/FeatureProvider';
import AcademiaSearchInput from '../../CommonComps/Inputs/AcademiaSearchInput';

const FilterFeaturesDiv = () => {
  // integration of context hooks here
  const { searchText, setSearchText } = useFeatureContext();

  // rendering filter features div component here
  return (
    <div className='flex flex-col md:flex-row items-center gap-3 justify-between mb-5 bg-legal-dark-blue shadow-academia-sm rounded-lg p-3'>
      <div
        className={`bg-base-white shadow-academia-sm w-full md:w-fit rounded-lg`}
      >
        <div className='w-1/5 min-w-full md:min-w-[280px]'>
          <AcademiaSearchInput
            searchText={searchText}
            setSearchText={setSearchText}
            inputLabel='Search Feature...'
            removeBorder
          />
        </div>
      </div>
    </div>
  );
};

export default FilterFeaturesDiv;
